import { useLingui } from "@lingui/react";
import FieldValuePair from "../FieldValuePair.tsx";
import { EuCheckLast } from "./EuCheck.tsx";
import type { SpecProps } from "./types.ts";

export const EuApproved = ({
  euApproved,
  euApprovedDate,
}: SpecProps<"eu_approved"> & SpecProps<"eu_approved_date">) => {
  const { i18n } = useLingui();

  if (!euApproved && !euApprovedDate) {
    return null;
  }

  const euApprovedText = i18n.t({
    id: "itemPageLayout.keyInfo.euApproved",
    message: "EU approved",
    comment: "Field for 'EU Approved' for bus or truck in ad specification",
  });

  return (
    <>
      {euApproved && <FieldValuePair field={euApprovedText} value={euApproved} />}
      {euApprovedDate && <EuCheckLast last={euApprovedDate} />}
    </>
  );
};
